import { Controller } from "@hotwired/stimulus"
const classes = require("util/classes")(__filename)

export default class extends Controller {
  static targets = ["track", "controls", "previous", "next"]

  connect() {
    this.update()
  }

  previous() {
    this.trackTarget.scrollBy({ left: -this.pageWidth() })
  }

  next() {
    this.trackTarget.scrollBy({ left: this.pageWidth() })
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.trackTarget
    this.controlsTarget.classList.toggle(classes("hidden"), scrollWidth <= clientWidth)
    this.previousTarget.disabled = scrollLeft <= 0
    this.nextTarget.disabled = scrollLeft + clientWidth >= scrollWidth - 1
  }

  pageWidth() {
    return this.trackTarget.clientWidth * 0.9
  }
}
